module.exports = __webpack_public_path__ + "img/tencentSecKill.c95141f6.jpg";